
export enum ProgramSubscriberDetailsViewTabs {
  DETAILS = "DETAILS",
  INTERNAL_NOTE_FORM = "INTERNAL_NOTE_FORM",
  PAUSE_FORM = "PAUSE_FORM",
  DISCOUNT_FORM = "DISCOUNT_FORM",
}